// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    cmsRegister: {
        text: null,
        tooltip: null,
    },
    cmsAdditional: {
        text: null,
        tooltip: null,
    },
    cmsPostFiocApproved: {
        text: null,
        tooltip: null,
    },
    cmsPostFiocNotApproved: {
        text: null,
        tooltip: null,
        title: null,
    },
    cmsStandBy: {
        text: null,
    },
});

const cms = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.LOAD_CMS_REGISTER:
            return state.merge({
                cmsRegister: action.data,
            });
        case actionTypes.LOAD_CMS_ADDITIONAL:
            return state.merge({
                cmsAdditional: action.data,
            });
        case actionTypes.LOAD_CMS_POSTFIOC_APPROVED:
            return state.merge({
                cmsPostFiocApproved: action.data,
            });
        case actionTypes.LOAD_CMS_POSTFIOC_NOT_APPROVED:
            return state.merge({
                cmsPostFiocNotApproved: action.data,
            });
        case actionTypes.LOAD_CMS_STAND_BY:
            return state.merge({
                cmsStandBy: action.data,
            });
        default:
            return state;
    }
};

module.exports = cms;
